import { Controller } from "@hotwired/stimulus";

// Inline question creation form rendered into a section by the type-picker.
// Autofocuses the title input on connect; cancel removes the form from the
// DOM without a server round-trip.
//
// Connect to: data-controller="new-question-form"
export default class extends Controller {
  static targets = ["titleInput"];

  declare readonly titleInputTarget: HTMLInputElement;
  declare readonly hasTitleInputTarget: boolean;

  connect() {
    if (this.hasTitleInputTarget) {
      requestAnimationFrame(() => this.titleInputTarget.focus());
    }
  }

  cancel(event: Event) {
    event.preventDefault();
    this.element.remove();
  }
}
